import { CreditTransaction } from "@custom-types/credit-types";
import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { CreditTransactionState } from "@store/credit-transactions/credit-transactions-slice-types";
import { fetchCreditTransactions } from "@store/credit-transactions/credit-transactions-thunk";
import { BaseEntityAdapter } from "@store/store-types";

export const creditTransactionAdapter: BaseEntityAdapter<CreditTransaction> =
  createEntityAdapter({
    selectId: (creditTransaction) => creditTransaction.id,
  });

export const initialState: CreditTransactionState = {
  ...creditTransactionAdapter.getInitialState(),
  fetching: {
    status: "uninitialized",
  },
  pagination: {
    before: null,
    after: null,
    totalCount: 0,
  },
};

const creditTransactionSlice = createSlice({
  name: "creditTransactions",
  initialState,
  reducers: {
    resetCreditTransactionState: () => initialState,
  },
  extraReducers(builder) {
    builder
      .addCase(fetchCreditTransactions.pending, (state) => {
        state.fetching.status = "pending";
      })
      .addCase(fetchCreditTransactions.fulfilled, (state, action) => {
        creditTransactionAdapter.upsertMany(state, action.payload.data);
        state.fetching.status = "succeeded";
        state.pagination.before = action.payload.before;
        state.pagination.after = action.payload.after;
        state.pagination.totalCount = action.payload.totalCount;
      })
      .addCase(fetchCreditTransactions.rejected, (state) => {
        state.fetching.status = "rejected";
      });
  },
});

export const { resetCreditTransactionState } = creditTransactionSlice.actions;

export const creditTransactionReducer = creditTransactionSlice.reducer;
